/**
 * @classdesc Classe utilitária para agrupar métodos de manipulação das propriedades do Material UI
 */
class MuiUtil {
    static ATRIBUTO_PADRAO = 'sx';
    static ATRIBUTO_SECUNDARIO = 'style';

    /**
     * Mescla as propriedades de estilos (sx e style).
     *
     * @param {Object} obj
     * @returns {Object} O objeto mesclado
     */
    static mesclarSxStyle(obj) {
        let objClonado = undefined;

        if (Object.prototype.hasOwnProperty.call(obj, MuiUtil.ATRIBUTO_SECUNDARIO)) {
            objClonado = JSON.parse(JSON.stringify(obj)); // [REVIEW] Testar o uso de "structuredClone" (Google Chrome >= v98)
            let estiloObj = { ...objClonado.sx, ...objClonado.style };
            delete objClonado[MuiUtil.ATRIBUTO_SECUNDARIO];
            objClonado[MuiUtil.ATRIBUTO_PADRAO] = estiloObj;
        }

        return objClonado !== undefined ? objClonado : obj;
    }

    /**
     * Mescla as propriedades, sobreescrevendo as propriedades padrão, se existirem.
     *
     * @param {Object} objeto1ComSxOuStyle
     * @param {Object} objeto2ComSxOuStyle
     * @returns {Object} O objeto mesclado
     */
    static mesclarEstilos(objeto1ComSxOuStyle, objeto2ComSxOuStyle) {
        let objeto1Mesclado = MuiUtil.mesclarSxStyle(objeto1ComSxOuStyle);
        let objeto2Mesclado = MuiUtil.mesclarSxStyle(objeto2ComSxOuStyle);

        if (!Object.prototype.hasOwnProperty.call(objeto2Mesclado, MuiUtil.ATRIBUTO_PADRAO)) {
            return objeto1Mesclado;
        }

        if (!Object.prototype.hasOwnProperty.call(objeto1Mesclado, MuiUtil.ATRIBUTO_PADRAO)) {
            objeto1Mesclado[MuiUtil.ATRIBUTO_PADRAO] = objeto2Mesclado[MuiUtil.ATRIBUTO_PADRAO];
            return objeto1Mesclado;
        }

        let estiloObj1 = JSON.parse(JSON.stringify(objeto1Mesclado[MuiUtil.ATRIBUTO_PADRAO]));
        let estiloObj2 = JSON.parse(JSON.stringify(objeto2Mesclado[MuiUtil.ATRIBUTO_PADRAO]));
        let estiloFinal = { ...estiloObj1, ...estiloObj2 };

        objeto1Mesclado[MuiUtil.ATRIBUTO_PADRAO] = estiloFinal;

        return objeto1Mesclado;
    }
}

export default MuiUtil;
